import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import InputBase from '@material-ui/core/InputBase';
import { glassmorphism, blur } from '../../AppConfig';

const useStyles = makeStyles(() => ({
  root: {
    backdropFilter: glassmorphism === true ? 'blur('+blur+')' : null,
    height: 54,
    display: 'grid',
    placeItems: 'center',
    margin: '12px',
    width: 'calc(100vw - 24px)',
    borderRadius: 8,
    '& > * > * > *': {
      textAlign: 'center'
    },
    '& > *': {
      width: '100%'
    },
    '& > * > *': {
      width: '100%'
    }
  }
}));

export default function SearchAppBar(props) {
  const classes = useStyles();
  const[placeholder, setPlaceholder] = React.useState('Tap to Search');
  
  function focused() {
    setPlaceholder('')
  }  

  function unfocused() {
    setPlaceholder('Tap to Search')
  }

  return (
      <AppBar color="inherit" style={{boxShadow: 'none', zIndex: '99999'}} className={classes.root}>
        <Toolbar variant="dense">
            <InputBase
              placeholder={placeholder}
              onKeyUp={searchFn}
              id="searchHere"
              inputProps={{ 'aria-label': 'search' }}
              onBlur={() => unfocused()}
              onFocus={() => focused()}
              autoComplete="off"
              className="searchAutoFocus"
            />
        </Toolbar>
      </AppBar>
  );
}

function searchFn() {
  var input = document.getElementById("searchHere");
  var filter = input.value.toLowerCase();
  var nodes = document.getElementsByClassName('searchContent');

  for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].innerText.toLowerCase().includes(filter)) {
          nodes[i].style.display = "block";
      } else {
          nodes[i].style.display = "none";
      }
  }
}

